import {
    Page,
    Badge,
    ResourceItem,
    ResourceList,
    Card,
    TextStyle,
    SkeletonBodyText
} from '@shopify/polaris';
import { apiFetch as fetch } from '../../common/Helpers';
import moment from 'moment';
import React, { Component } from 'react'
import { Helmet } from 'react-helmet';
import Cookies from "js-cookie";

class ValidationsViewPage extends Component {

    constructor(props) {
        super(props)
        const { params } = this.props.match;
        this.state = {
            id: params.id,
            isLoading: true,
            validation: null
        };
    }

    componentDidMount() {
        fetch(`api/validations/${this.state.id}`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => this.setState({
                validation: {
                    id: data.id,
                    name: data.name,
                    invalidProducts: data.invalidProducts
                },
                isLoading: false
            }));
    }

    renderValidationErrorItem = (item) => {
        const { id, legacyId, message, productName } = item;

        return (
            <ResourceItem id={id} url={null} onClick={(e) => this.handleProductItemClick(e, legacyId)}>
                <h3>
                    <TextStyle variation="strong">{productName}</TextStyle>
                </h3>
                <div>{message}</div>
            </ResourceItem>
        );
    }

    handleProductItemClick = (e, id) => {
        const shopOrigin = Cookies.get("shopOrigin");
        window.open(`https://${shopOrigin}/admin/products/${id}`, '_blank');
    }

    render() {
        if (this.state.isLoading)
            return <SkeletonBodyText lines="20" />;

        let items = this.state.validation.invalidProducts.map((item, index) => {
            return {
                id: index,
                url: null,
                productName: item.productName,
                message: item.message,
                legacyId: item.legacyId
            }
        });

        let preview = (<div>No errors</div>);

        let hasErrors = items.length > 0;
        if (hasErrors) {
            preview = (
                <ResourceList
                    resourceName={{ singular: 'error', plural: 'errors' }}
                    items={items}
                    renderItem={this.renderValidationErrorItem}
                />)
        }


        return (
            <div>
                <Helmet>
                    <title>Tag Genie - View Validation</title>
                </Helmet>
                <Page
                    title={`Validation: ${this.state.validation.name}`}
                    breadcrumbs={[{ content: 'View Validation', url: '/validations' }]}
                    secondaryActions={[{ content: 'Edit', onAction: () => { this.handleEditValidation(); } }]}
                >
                    <Card >
                        {preview}
                    </Card>
                </Page>
            </div>
        );
    }

    renderItem(item) {
        const { id, name, lastRun, invalidProductsCount } = item;

        return (
            // <ResourceItem id={id} url={null} onClick={(e) => handleItemClick(e, item)}>
            <ResourceItem id={id} url={null} >
                <div>
                    <div className="operationItemContent">
                        <div className="operationItemContentColumn">
                            <TextStyle variation="strong">{name}</TextStyle>
                        </div>
                        <div className="operationItemContentRight">
                            {invalidProductsCount === 0 && <div>
                                <Badge status="success">Validation passed</Badge>
                            </div>}
                            {invalidProductsCount > 0 && <div>
                                <Badge status="critical">{invalidProductsCount} failing products</Badge>
                            </div>}
                        </div>
                    </div>
                    <span className="operationDescription">Last run - {lastRun.toString()}</span>
                </div>
            </ResourceItem>
        );

    }

    parseDate(stringDate) {
        var momentDate = moment(stringDate);
        return momentDate.toDate();
    }

    handleEditValidation() {
        this.props.history.push(`/validations/${this.state.id}/edit`);
    }
}

export default ValidationsViewPage